module.exports = __webpack_public_path__ + "img/dedicated-proxy.34e5cf6f.svg";